export default __webpack_public_path__ + "static/media/office.3e3e2f9a.svg";